/*
 * currentOrganizationId reducer
 */
import { SET_CURRENT_ORGANIZATION_ID } from './constants';

type State = string;

type Action = {
    +type: string,
    +payload: Object
};

const initialState = '';

export default function(state: State = initialState, action: Action) {
    switch (action.type) {
        case SET_CURRENT_ORGANIZATION_ID:
            return action.payload.organizationId;
        default:
            return state;
    }
}
